/**
 * @function debounce
 * @description
 * Execute a callback after X miliseconds. Every time the callback is called
 * and the previous one has not yet run, the delay is renewed.
 * `debounce` is used for performance reasons, for example in the
 * case of resize events that are called continuously in some browsers.
 *
 * ```js
 * import debounce from 'datajs/src/utils/debounce';
 *
 * document.addEventListener('resize', debounce(onResize, 200));
 *
 * function onResize() {
 *     // do something after resize
 * }
 * ```
 *
 * @param {Function} fn - The callback to debounce
 * @param {Number} threshold - A positive integer representing the delay before
 * calling `fn`
 * @param {Boolean} [isAsap] - The callback is called immediately and after
 * the given delay (useful in some situations)
 * @returns {Function} The debounced callback
 */
export default function(fn, threshold, isAsap) {
    var timeout, result;

    function debounced() {
        var args = arguments, context = this;

        function delayed() {
            if(!isAsap) {
                result = fn.apply(context, args);
            }

            timeout = null;
        }

        if(timeout) {
            clearTimeout(timeout);
        } else if(isAsap) {
            result = fn.apply(context, args);
        }

        timeout = setTimeout(delayed, threshold);

        return result;
    }
    return debounced;
}
